import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteLiveAccount = async ({ id }) => {
  const { data } = await SigliveServiceV1({ method: 'DELETE', url: `/account-livestream/${id}` });

  return data;
};

export default deleteLiveAccount;
